// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as OpeningButton from "../../resources/actions/OpeningButton.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductStockTableCell from "../Product/ProductStockTableCell.res.js";
import * as CatalogVariantStockThresholdFormPopover from "./CatalogVariantStockThresholdFormPopover.res.js";

function CatalogVariantStockThresholdCell(props) {
  let bulk = props.bulk;
  let stockState = props.stockState;
  let stockQuantity = props.stockQuantity;
  let __compact = props.compact;
  let compact = __compact !== undefined ? __compact : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = Auth.useScope();
  let exit = 0;
  if (match$1.TAG === "Organisation") {
    if (match$1.activeShop === undefined) {
      return JsxRuntime.jsx(ProductStockTableCell.make, {
        value: stockQuantity,
        state: stockState,
        size: compact ? "xsmall" : "normal",
        formattedShopsNames: props.formattedShopsNames
      });
    }
    exit = bulk ? 2 : 1;
  } else {
    exit = bulk ? 2 : 1;
  }
  switch (exit) {
    case 1 :
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(OpeningButton.make, {
            children: JsxRuntime.jsx(ProductStockTableCell.make, {
              value: stockQuantity,
              state: stockState,
              size: compact ? "xsmall" : "normal"
            }),
            ariaProps: popoverAriaProps.triggerProps,
            opened: popover.isOpen,
            onPress: param => popover.toggle(),
            ref: popoverTriggerRef
          }),
          popover.isOpen ? JsxRuntime.jsx(CatalogVariantStockThresholdFormPopover.make, {
              popover: popover,
              popoverAriaProps: popoverAriaProps,
              popoverTriggerRef: popoverTriggerRef,
              variantId: props.id,
              maxStockThreshold: props.maxStockThreshold,
              minStockThreshold: props.minStockThreshold,
              stockOrderTriggerThreshold: props.stockOrderTriggerThreshold
            }) : null
        ]
      });
    case 2 :
      return JsxRuntime.jsx(JsxRuntime.Fragment, {
        children: JsxRuntime.jsx(ProductStockTableCell.make, {
          value: stockQuantity,
          state: stockState,
          size: compact ? "xsmall" : "normal"
        })
      });
  }
}

let make = React.memo(CatalogVariantStockThresholdCell);

export {
  make,
}
/* make Not a pure module */
